import { injectable, injectFromBase } from 'inversify'
import Facet from '@/data/models/facets/Facet'
import OrmApiRepository from '@/data/repositories/ormApiRepository'
import { RepoSettings } from '@/decorators/repositoryDecorators'

@RepoSettings({
  model: Facet,
})
@injectable()
@injectFromBase()
export default class FacetRepository extends OrmApiRepository<Facet> {}
